import React, { useEffect, useState } from 'react';
import { Col, Divider, Row } from 'antd';
import moment from 'moment';
import { getProjectAccounting } from '@gtintel/platform-api';
import { CURRENCY_SYMBOLS } from '@gtintel/platform-constants';
import * as S from '../styles';
import ConvertedFeeStatistic from './ConvertedFeeStatistic';
import { StyledStatistic } from './StyledStatistic';
const AccountingDetail = ({
  projectId
}) => {
  const [accounting, setAccounting] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    getProjectAccounting(projectId).then(accounting => setAccounting(accounting)).catch(() => {
      setAccounting({
        revenue: 0,
        revenue_conversion_date: new Date(),
        cost: 0,
        cost_conversion_date: new Date(),
        partner_fee: 0,
        partner_currency: 'USD',
        partner_fee_conversion_date: new Date(),
        profit: 0,
        gross_margin: 0,
        modified_date: new Date()
      });
    }).finally(() => setLoading(false));
  }, [projectId]);
  return <>
      <S.DetailRows>
        <Col>
          <S.Header>GTI</S.Header>
          <ConvertedFeeStatistic title="Revenue" value={accounting?.revenue} precision={2} prefix="£" loading={loading} conversionDate={new Date(accounting?.revenue_conversion_date)} />
          <ConvertedFeeStatistic title="COGS" value={accounting?.cost} precision={2} prefix="£" loading={loading} conversionDate={new Date(accounting?.cost_conversion_date)} />
        </Col>

        <Col>
          <S.Header>Partner</S.Header>
          <ConvertedFeeStatistic title="Partner Fee" value={accounting?.partner_fee} precision={2} prefix={CURRENCY_SYMBOLS[accounting?.partner_currency.toUpperCase()]} loading={loading} conversionDate={new Date(accounting?.partner_fee_conversion_date)} />
        </Col>
      </S.DetailRows>
      <Divider />
      <S.DetailRows>
        <Col>
          <StyledStatistic title="Gross Profit" value={accounting?.profit} precision={2} prefix="£" loading={loading} />
        </Col>
        <Col>
          <StyledStatistic title="Gross Margin" value={accounting?.gross_margin * 100} precision={2} suffix="%" loading={loading} />
        </Col>
      </S.DetailRows>
      <Row>
        <S.Deemphasized>
          Updated{' '}
          {moment(accounting?.modified_date).format('DD/MM/YY, h:mm:ss a')}
        </S.Deemphasized>
      </Row>
    </>;
};
export default AccountingDetail;